import * as Amplitude from '@amplitude/node';
import { AMPLITUDE_API_KEY } from '@/constant';

const AmplitudeInstance = Amplitude.init(AMPLITUDE_API_KEY);

export default AmplitudeInstance;
